<template>
  <section class="table_pad">
    <p class="table_title">{{tableTitle}}</p>
    <div class="table_scroll">
      <table class="table_list" cellspacing="0" cellpadding="0">
        <thead>
          <tr class="table_title_tr">
            <th v-for="(item, index) in titleList" :key="index">{{item.name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in dataList" :key="index" class="table_data_tr" :class="{'is_total': item.name === '合计'}">
            <td v-for="(v, Xindex) in titleList" :key="Xindex">
              <cell class="single_store" v-if="isLink && Xindex === 0 && item[v.key] !== '合计'" :title="item[v.key]" :link="`${url}/${item.store_id}`">
              </cell>
              <template v-else-if="Array.isArray(item[v.key])">
                <p v-for="(i, index) in item[v.key]" :key="index">{{i}}</p>
              </template>
              <span v-else>{{item[v.key]}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
import {
  Cell
} from '@lx-frontend/cvux'
export default {
  components: {
    Cell
  },
  props: {
    tableTitle: { // 表单标题
      type: String,
      default: '列表信息'
    },
    titleList: { // 表头
      type: Array,
      default() {
        return []
      }
    },
    dataList: { // 列表数据
      type: Array,
      default() {
        return []
      }
    },
    isLink: {
      type: Boolean,
      default: false
    },
    url: [Number, String]
  }
}

</script>
<style lang="less">
@import '../../../stylesheets/base/fn';
.table_pad {
  overflow: hidden;
  background-color: #fff;
  padding: 20/@w2 30/@w2;
  .table_title {
    color: #666666;
    font-size: 26/@w2;
    margin-bottom: 30/@w2;
  }
  .table_scroll {
    overflow: auto;
    white-space: nowrap;
  }
  .table_list {
    color: #5b6984;
    width: 100%;
    .table_title_tr{
      background-color: #f1f4fb;
      line-height: 96/@w2;
      th {
        text-align: center;
        border-bottom: 1px solid #e7e7e9;
        padding: 0 30/@w2;
        font-size: 26/@w2;
      }
      th:first-child{
        text-align: left;
      }
    }
    .table_data_tr {
      color: #000;
      line-height: 96/@w2;
      .single_store {
        padding: 0;
        .weui_cell_bd div{
          width: 170/@w2;
          white-space: normal;
          line-height: 1.6;
          padding: 15/@w2 0;
          color: #5b6984;
        }
      }
      td {
        text-align: center;
        border-bottom: 1px solid #e7e7e9;
        font-size: 26/@w2;
        padding: 0 10/@w2;
        p {
          line-height: 42/@w2;
        }
      }
      td:first-child{
        border-right: 1px solid #e7e7e9;
        border-left: 1px solid #e7e7e9;
        color: #5b6984;
        text-align: left;
        padding-left: 30/@w2;
        padding-right: 30/@w2;
      }
      td:last-child{
        border-right: 1px solid #e7e7e9;
      }
    }
    .is_total{
      color: #fb3f3f;
      td:first-child{
        color: #fb3f3f;
      }
    }
  }

}

</style>
